import { Link } from 'libs/router/Link';

import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './CareerCard.module.scss';

type Props = {
  name: string;
  category: string;
  location: string;
  slug: string;
  index?: number;
};

const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M2.917 11.083 11.083 2.917M11.083 2.917H4.083M11.083 2.917v7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CareerCard = ({ name, category, location, slug, index = 0 }: Props) => {
  return (
    <Link
      className={styles['career-card-link']}
      route={slug}
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className={styles['career-card-wrapper']}>
        <div className={styles['details-wrapper']}>
          <div className={styles['name']}>{name}</div>

          <div className={styles['job-details']}>
            <div className={styles['detail']}>
              <Icon type="job-type" className={styles['detail-icon']} />
              <div className={styles['detail-name']}>{category}</div>
            </div>

            <div className={styles['detail']}>
              <Icon type="job-location" className={styles['detail-icon']} />
              <div className={styles['detail-name']}>{location}</div>
            </div>
          </div>
        </div>

        <div className={styles['button-wrapper']}>
          <div className={styles['button']}>
            <ArrowIcon />
          </div>
        </div>
      </div>
    </Link>
  );
};
